import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=14860c6e&scoped=true"
import script from "./ClientDetails.vue?vue&type=script&lang=ts"
export * from "./ClientDetails.vue?vue&type=script&lang=ts"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=14860c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14860c6e",
  null
  
)

export default component.exports